import { Navigate } from "react-router-dom";

//trade
import TradePage from "../pages/Trade";

// TokenPage
import TokenPage from "../pages/Token";

// WalletPage
import WalletPage from "../pages/Wallet";

// CampaignPage
import CampaignPage from "../pages/Campaign";

// PoolPage
import PoolPage from "../pages/Pool";

// Settings
import TradeSetting from "../pages/Settings/components/TradeSetting";
import WalletSetting from "../pages/Settings/components/WalletSettings";
import AlertSetting from "../pages/Settings/components/AlertSetting";

//pages
import ComingSoon from "../pages/Pages/ComingSoon/ComingSoon";
import Settings from "../pages/Pages/Profile/Settings/Settings";

//login
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile

import Profile from "pages/User/Profile";
import UserProfile from "../pages/Authentication/user-profile";

import RoleList from "pages/User/Role";
import UserList from "pages/User/User";

import Configuration from "pages/Configuration";

import AdminActivityLogs from "pages/Logging/AdminActivityLogs";
import DailyStatistic from "pages/Statistics/DailyStatistic";

import DailyImpressionStatistic from "pages/Statistics/DailyImpressionStatistic";
import LiquidityLog from "pages/Monitoring/LiquidityLog";
import TransactionLog from "pages/Monitoring/TransactionLog";
import EventLog from "pages/EventLog";

const ROUTES = {
  TOKEN: "/token",
  TRADE: "/trade",
  WALLET: "/wallet",
  CAMPAIGN: "/campaign",
  POOL: "/pool",
  TRADE_SETTINGS: "/settings/trade-settings",
  WALLET_SETTINGS: "/settings/wallet-settings",
  ALERT_SETTINGS: "/settings/alert-settings",


  LIQUIDITY_LOG: "/monitoring/liquidity-log",
  TRANSACTION_LOG: "/monitoring/transaction-log",
  EVENT_LOG: "/event-log",

  PROFILE: "/profile",
  PROFILE_SETTING: "/pages-profile-settings",

  USER_LIST: "/user/list",
  USER_ROLE: "/user/role",
  USER_PROFILE: "/user/profile",
  MANAGEMENT_PROXY: "/user/proxy",

  ADMIN_ACTIVITY_LOGS: "/logging/admin-activity-logs",

  CONFIGURATION: "/configuration",

};

const authProtectedRoutes = [
  { path: ROUTES.TRADE, component: <TradePage /> },
  { path: ROUTES.TOKEN, component: <TokenPage /> },
  { path: ROUTES.WALLET, component: <WalletPage /> },
  { path: ROUTES.CAMPAIGN, component: <CampaignPage /> },
  { path: ROUTES.POOL, component: <PoolPage /> },
  { path: ROUTES.TRADE_SETTINGS, component: <TradeSetting /> },
  { path: ROUTES.WALLET_SETTINGS, component: <WalletSetting /> },
  { path: ROUTES.ALERT_SETTINGS, component: <AlertSetting /> },

  { path: ROUTES.LIQUIDITY_LOG, component: <LiquidityLog /> },
  { path: ROUTES.TRANSACTION_LOG, component: <TransactionLog /> },
  { path: ROUTES.EVENT_LOG, component: <EventLog /> },

  { path: ROUTES.PROFILE_SETTING, component: <Settings /> },
  { path: ROUTES.PROFILE, component: <UserProfile /> },

  { path: ROUTES.USER_LIST, component: <UserList /> },
  { path: ROUTES.USER_ROLE, component: <RoleList /> },
  { path: ROUTES.USER_PROFILE, component: <Profile /> },

  { path: ROUTES.CONFIGURATION, component: <Configuration /> },

  { path: ROUTES.ADMIN_ACTIVITY_LOGS, component: <AdminActivityLogs /> },

  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to={ROUTES.TRADE} />,
  },
  { path: "*", component: <Navigate to={ROUTES.TRADE} /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },

  //AuthenticationInner pages
  { path: "/pages-coming-soon", component: <ComingSoon /> },
];

export { authProtectedRoutes, publicRoutes, ROUTES };
